// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"533":"01372747","773":"dac4869d","980":"8db257cb"}[chunkId] + ".chunk.css";
};